<template>
  <div class="app-step">
    <div class="app-step__header">
      <h4 class="app-step__title">{{ title }}</h4>
      <p class="app-step__tip">{{ tip }}</p>
    </div>
    <div class="app-step__body">
      <slot name="body"></slot>
    </div>
    <div class="app-step__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppStep',
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.app-step {
  &__header {
    padding: 0;
  }

  &__body {
    padding: 50px 0 80px;
  }

  &__footer {
    text-align: center;
  }

  &__title {
    margin: 0;
  }

  &__tip {
    padding: 6px 8px;
    margin-top: 10px;
    margin-bottom: 0;
    border: 1px solid #ffcccc;
    background-color: #ffeded;
    color: #ec6868;
    font-size: 12px;
    line-height: 1;
  }
}
</style>
